import axios from 'axios';
import {
    PARTNERSHIP_API,
    API_HEADER
} from '../../../constants/API'
import {
    CREATE_PARTNERSHIP_LOADING
} from '../types';
import { message } from 'antd';

export default (data) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: CREATE_PARTNERSHIP_LOADING,
                creatingPartnership: true
            })
            const { token, dbUser } = getState().UserReducer;
            const postData = { ...data, userId: dbUser.id }
            await axios.post(`${PARTNERSHIP_API}`, postData, API_HEADER(token))
            dispatch({
                type: CREATE_PARTNERSHIP_LOADING,
                creatingPartnership: false
            })
            return true;

        } catch(e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }            
            dispatch({
                type: CREATE_PARTNERSHIP_LOADING,
                creatingPartnership: false
            })
            return false

        }
    }
}